<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-btn
        class="mr-1"
        :outlined="$vuetify.breakpoint.smAndUp"
        :icon="$vuetify.breakpoint.xs"
        v-on="on"
      >
        <v-avatar
          size="25"
          :class="$vuetify.breakpoint.smAndUp ? 'mr-2' : 'mr-0'"
        >
          <v-img
            :src="locale.icon"
          />
        </v-avatar>
        {{ $vuetify.breakpoint.smAndUp ? locale.title : '' }}
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(item, index) in locales"
        :key="index"
        @click="setLang(item)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { languages } from '../plugins/i18n'

export default {
  computed: {
    /**
       * @desc get the current language in that's using in the system
       * @returns {[{backendRecord: string, icon: string, locale: string, title: string, bc47Code: string}, {backendRecord: string, icon: string, locale: string, title: string, bc47Code: string}]}
       */
    locales () {
      return languages
    },
    /**
       * @desc get the current language
       * @returns {{backendRecord: string, icon: string, locale: string, title: string, bc47Code: string} | {backendRecord: string, icon: string, locale: string, title: string, bc47Code: string}}
       */
    locale () {
      return languages.find(x => x.locale === this.$i18n.locale)
    }
  },
  methods: {
    /**
       * @desc set language based on the user input
       * @param item
       */
    setLang (item) {
      this.$store.commit('account/localLang', item.locale)
      this.$i18n.locale = item.locale
    }
  }
}
</script>
